import { Button } from '@/components/ui/button';
import { useNavigation } from '@/context/NavigationContext';
import { buildAccountRoute, type AccountWorkspaceSection } from '@/lib/account-routing';

const tabs: Array<{ id: AccountWorkspaceSection; label: string }> = [
  { id: 'overview', label: 'Overview' },
  { id: 'services', label: 'Services' },
  { id: 'tickets', label: 'Support' },
  { id: 'billing', label: 'Billing' }
];

interface AccountWorkspaceTabsProps {
  accountId: string;
  current: AccountWorkspaceSection;
}

export default function AccountWorkspaceTabs({ accountId, current }: AccountWorkspaceTabsProps) {
  const { navigate } = useNavigation();

  return (
    <div className="flex flex-wrap gap-2">
      {tabs.map(tab => (
        <Button
          key={tab.id}
          type="button"
          size="sm"
          variant={current === tab.id ? 'default' : 'outline'}
          onClick={() => navigate(tab.id === 'tickets' ? '/support' : buildAccountRoute(accountId, tab.id))}
        >
          {tab.label}
        </Button>
      ))}
    </div>
  );
}
